import { combineReducers } from "redux";
import SeTu from "./seTu"

export default combineReducers({
    SeTu
});